import { getGenreCategoryList } from "@/api/adapter.api";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { getCategoryMapTypesV2, getGenresV2 } from "../genre.api";
import { CategoryMapType } from "../types/genre";

export class CategoryService {
  static async fetchCategoryListByGenreV1(genreName: string): Promise<PortalAdapterApi.GenreCategoryType> {
    return await getGenreCategoryList(genreName);
  }

  static async fetchGenresV2(country = "jp", mapType?: string): Promise<PortalAdapterApi.ResponseGetPlaceCategoryList> {
    return await getGenresV2(country, mapType);
  }

  static async fetchMapTypesForGenres(genreNames: string): Promise<CategoryMapType[]> {
    return await getCategoryMapTypesV2(genreNames);
  }
}
